<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <span class="title_head">Search Purchase Return</span>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-sm-12 alert alert-success" v-if="haserror.message!=''" style="text-align:center;">{{haserror.message}}</div>
            </div>
            <b-row>
              <b-col sm="4">
                <b-form-group>
                  <label for="name">Supplier Name :</label>
                  <span style="display: flex;" v-if="dd_show === true">
                    <model-list-select :list="customername" option-value="sup_cmp_name" :custom-text="nameAndnumber" v-model="selectedcustomer" @input="onSelectSup($event)" placeholder="Search Supplier Name" @searchchange="searchcustomer" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;  white-space: nowrap;"></model-list-select>&nbsp;&nbsp;
                    <!-- <a href="#/purchase/supplier/add"><button type="button" class="btn btn-pill btn-primary" route v-b-tooltip.hover title="Add New Supplier"><i class="fa fa-user"></i></button></a> 
                    <button type="button" class="btn btn-pill btn-primary" route v-b-tooltip.hover title="Add New Supplier" @click="addSupplier()"><i class="fa fa-user"></i></button>-->
                  </span>
                  <span v-else>
                    <input type="text" class="form-control" id="sup_name" name="txtSupName" v-model="selectsupname" autocomplete="off" :disabled=true>
                  </span>
                  <small class="form-text text-muted"><strong style="color: red;">{{haserror.cust}}</strong></small>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group>
                  <label for="name">Shop Name</label>
                  <span style="display: flex;" v-if="dd_show === true">
                    <model-list-select @input="onSelectShp()" :list="shopname" option-value="est_shop_id" option-text="est_shop_name" v-model="selectshop" placeholder="Select Shop" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:20px !important;border: 1px solid rgb(194, 207, 214);min-height: 35px;"></model-list-select>&nbsp;&nbsp;
                    <!-- <a href="#/companyinfo/Shop"><button type="button" class="btn btn-pill btn-primary" v-b-tooltip.hover title="Add New Shop"><i class="fa fa-plus"></i></button></a> 
                    <button type="button" @click="addShop()" class="btn btn-pill btn-primary" v-b-tooltip.hover title="Add New Shop"><i class="fa fa-plus"></i></button>-->
                  </span>
                  <span v-else>
                    <input type="text" class="form-control" id="shop_name" name="txtShopName" v-model="selectshopname" autocomplete="off" :disabled=true>
                  </span>
                  <small class="form-text text-muted"><strong style="color: red;">{{haserror.shop}}</strong></small>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group>
                  <span v-if="dd_show === true">
                    <label for="name">Scan Barcode</label>
                    <input type="text" class="form-control" name="barcode" v-model="barcode" @blur="searchBarcode" @keyup="checkShop" autocomplete="off"  placeholder="Enter Product Barcode Number">&nbsp;&nbsp;
                    <small class="form-text text-muted"><strong style="color: red;">{{haserror.barcode}}</strong></small>
                  </span>
                  <span v-else>
                    <label for="name">Purchase Id</label>
                    <input type="text" class="form-control" autocomplete="off" name="txtpurchase_id" v-model="purchase_id" placeholder="Purchase ID" :disabled=true>
                  </span>
                </b-form-group>
              </b-col>

            </b-row>
          </div>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <span class="title_head">ITEM DETAILS</span>
          </div>
          <div class="card-body" style="padding:0px !important;">
            <div class="">
              <table class="table table-striped table-responsive">
                <thead>
                  <tr style="font-size: 12px; text-align: center;">
                    <th width="20%">Product Name</th>
                    <th width="8%">Unit</th>
                    <th width="9%">Qty</th> 
                    <th width="12%">Purchase Price/Unit</th> 
                    <th width="12%">Amt Before Tax</th> 
                    <th width="6%" v-if="is_cs_gst">SGST %</th> 
                    <th width="6%" v-if="is_cs_gst">CGST %</th>            
                    <th width="6%" v-if="is_i_gst">IGST %</th> 
                    <th width="14%">Total</th>
                    <th width="6%">Other</th>
                  </tr>
                </thead>
                <input type="hidden" name="qty1" id="qty1" value=""> 
                <tbody id="product_table_body">
                  <tr v-for="(row, index) in rows">
                     <!--<td>
                      <a v-if="dd_show === true" href="#/setup/addupdateproduct"><i class="fa fa-plus sale_plus" v-b-tooltip.hover title="Add New Product"></i></a> 
                      <a v-if="dd_show === true" style="font-size:14px;color: #20a8d8; cursor:pointer;" @click="addProduct()"><i class="fa fa-plus" v-b-tooltip.hover title="Add New Product"></i></a>
                    </td>-->
                    <td>
                     <span v-if="dd_show === true">
                     <model-list-select :list="row.productnamex" option-value="product_id" option-text="product_name" v-model="row.selectproductrow" placeholder="Search Product Name" @input="openvariant($event,index)" @searchchange="searchprd3($event,index,row)" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:30px !important; border: 1px solid rgb(194, 207, 214);min-height: 30px; border-radius: 1px; padding-top: 6px;" class="product-drop"></model-list-select>
                      <small style="font-size:  10px;color: darkblue; cursor:pointer;"  v-if="row.productExist !=''"> {{row.productExist}}</small>
                      <small style="font-size:  10px; color: red; cursor:pointer;" @click="openvariant(row,index)" v-if="row.show==true">Variant <i class="fa fa-info-circle"></i> {{row.variantrow}}</small>
                      <small style="font-size:  10px; color: red;" v-if="row.show1==true">Variant : {{row.variantrow}}</small>
                    </span>
                    <span v-else>
                     <model-list-select :list="row.productnamex" option-value="product_id" option-text="product_name" v-model="row.selectproductrow" placeholder="Search Product Name" style="-webkit-text-fill-color: rgb(83, 108, 121) !important; height:30px !important; border: 1px solid rgb(194, 207, 214);min-height: 30px; border-radius: 1px; padding-top: 6px;" class="product-drop"></model-list-select>
                     <small style="font-size:  10px;color: darkblue; cursor:pointer;"  v-if="row.productExist !=''"> {{row.productExist}}</small>
                     <small style="font-size:  10px; color: red; cursor:pointer;" v-if="row.show==true">Variant <i class="fa fa-info-circle"></i> {{row.variantrow}}</small>
                     <small style="font-size:  10px; color: red;" v-if="row.show1==true"> Variant : {{row.variantrow}}</small>
                   </span>
                 </td>
                 <td>
                  <input class="form-control-sm" type="text" autocomplete="off"  v-model="row.unit" disabled style="width: 100%;">
                </td>
                <td>
                  <input type="text" class="form-control-sm" autocomplete="off"  v-model="row.qty" style="width: 100%;" v-on:change="price(index);"><br>
                  <small style="font-size: 10px; color: red;" v-if="row.err_qty!=''">{{row.err_qty}}<br></small>
                  <small style="font-size:  10px;color: green;margin-top: 41px;" v-b-tooltip.hover title="Available Qty in Stock" v-if="row.avaqty!=''">Qty : {{row.avaqty}}</small>
                  <small style="font-size:  10px;color: green;margin-top: 41px;" v-b-tooltip.hover title="max quantity" v-if="row.maxqty!=''">Max Qty : {{row.maxqty}}</small>
                </td>
                <td>
                  <input type="text" style="width: 100%;" autocomplete="off"  v-model="row.price" class="form-control-sm"  v-on:change="price(index);"></br>
                  <small style="font-size: 10px; color: red;" v-if="row.err_price!=''">{{row.err_price}}<br></small>
                  <small style="font-size:  10px;color: green;margin-top: 41px;" v-b-tooltip.hover title="Price" v-if="row.priceqty!=''">Price : {{row.priceqty}}</small>
                </td>
                <td>
                  <input type="text" style="width: 100%;" autocomplete="off"  class="form-control-sm" v-model="row.amt" disabled="">
                </td>
                <td v-if="is_cs_gst">
                  <input type="text" style="width: 100%;" class="form-control-sm" v-model="row.sgst" autocomplete="off"   v-on:change="price(index);">
                  <small style="font-size: 10px; color: red;" v-if="row.err_sgst!=''">{{row.err_sgst}}<br></small>
                </td>  
                <td v-if="is_cs_gst">
                  <input type="text" style="width: 100%;" class="form-control-sm" v-model="row.cgst" autocomplete="off"  v-on:change="price(index);" >
                  <small style="font-size: 10px; color: red;" v-if="row.err_cgst!=''">{{row.err_cgst}}<br></small>
                </td>
                <td v-if="is_i_gst">
                  <input type="text" style="width: 100%;" class="form-control-sm" v-model="row.igst" autocomplete="off"   v-on:change="price(index);">
                  <small style="font-size: 10px; color: red;" v-if="row.err_igst!=''">{{row.err_igst}}<br></small>
                </td> 
                <td>
                  <input type="text" disabled="disabled"  v-model="row.amttotal" style="width: 100%;" autocomplete="off"  class="form-control-sm">
                </td>
                <td>
                  <center>
                    <i class="fa fa-reorder" style="color: #20a8d8;" v-b-tooltip.hover title="Add More option" variant="secondary" @click="openmodal(index)"></i>
                    <i class="fa fa-trash-o" style="color: #F44336;" v-b-tooltip.hover title="Delete" v-on:click="removeElement(index);"></i>

                  </center>
                </td>
              </tr>
              <tr>
                <td>
                  <div v-if="dd_show === true" style="font-size:  13px;color: green;">Add New Row: <span style="cursor:  pointer;" @click="addRow1" class="badge badge-pill badge-info" v-b-tooltip.hover title="Add New Row">Add</span></div>
                </td>
                <td colspan="9" style="text-align: right;">Total Items Discount: 
                  <input type="text" class="form-control-sm" disabled="" :value="totaldis">
                </td>
              </tr>

              <tr>
                <td></td>
                <td colspan="9" style="text-align: right;">Additional Discount: 
                  <input type="" class="form-control-sm" v-on:change="discountadd" v-model="detail.addition"></td>
                </tr>
                <tr>
                  <td></td>
                  <td colspan="9" style="text-align: right;">Total Amount Before Tax: 
                    <input type="" class="form-control-sm" :value="totalamt" disabled=""></td> 
                  </tr>
                  <tr  v-if="is_cs_gst">
                    <td></td>
                    <td colspan="9" style="text-align: right;">SGST: <input type="text" class="form-control-sm" disabled="" :value="totalsgst"></td>
                  </tr>
                  <tr v-if="is_cs_gst">
                    <td></td>
                    <td colspan="9" style="text-align: right;">CGST: <input type="text" class="form-control-sm" disabled="" :value="totalcgst"></td>
                  </tr>
                  <tr  v-if="is_i_gst">
                    <td></td>
                    <td colspan="9" style="text-align: right;">IGST: <input type="text" class="form-control-sm" disabled="" :value="totaligst"></td>
                  </tr>
                  <tr>
                    <td style="text-align: left; ">Payment: </td>
                    <td style="text-align: left; ">
                      <b-form-select v-model="selected_pytype" :options="lst_paymenttype" v-on:change="paychange"></b-form-select>
                    </td>
                    <td  colspan="8" style="text-align: right;">Total Tax Amount: <input type="text" :value="totaltax" disabled="" class="form-control-sm"></td>
                  </tr> 
                  <tr> 
                    <td colspan="3" style="text-align: left; ">
                      <b-form-group label="">
                        Payment Mode:
                        <b-form-radio v-model="selected_pymode" name="payment_mode" value="cash" v-on:change="modechange">Cash</b-form-radio>
                        <b-form-radio v-model="selected_pymode" name="payment_mode" value="cheque" v-on:change="modechange">Cheque</b-form-radio>
                      </b-form-group>
                    </td>
                    <td colspan="7" style="text-align: right;">Total Amount To Pay: <input type="text" :value="totalamtpay" disabled="" class="form-control-sm"></td> 
                  </tr> 
                  <tr v-if="fullpay === true" style="">
                    <td></td>
                    <td colspan="9" style="text-align: right;">Amount Received: <input type="text" v-on:change="calchnge();" class="form-control-sm" v-model="totalamtreceived"></td> 
                  </tr>
                  <tr v-if="fullpay === true" style="">
                    <td></td>
                    <td colspan="9" style="text-align: right;">Change: <input type="text" class="form-control-sm" disabled="" v-model="chng"></td> 
                  </tr>
                  <tr v-if="parpay === true" style="">
                    <td></td>
                    <td colspan="9" style="text-align: right;">Amount Received: <input type="text" class="form-control-sm" v-model="totalparamtreceived" v-on:change="calbalance();">
                    <br><small style="font-size: 10px; color: red;" v-if="amt_rec != ''" >{{amt_rec}}</small></td> 
                  </tr>
                  <tr v-if="parpay === true" style="">
                    <td></td>
                    <td colspan="9" style="text-align: right;">Balance: <input type="text" class="form-control-sm" disabled="" v-model="bal"></td> 
                  </tr>
                  <tr v-if="chqpay === true" style="">
                    <td></td>
                    <td colspan="9" style="text-align: right;">Cheque No.: <input type="text" name="cheque_no" autocomplete="off" v-model="cheque_no" class="form-control-sm" placeholder="Enter Cheque No">
                    <br>
                  <small style="font-size: 10px; color: red;" v-if="chequeno_validate != ''" >{{chequeno_validate}}</small></td>
                  </tr>
                  <tr v-if="chqpay === true" style="">
                    <td></td>
                    <td colspan="9" style="text-align: right;">Cheque Date.: <date-picker v-model="cheque_date" editable lang="en" class="form-control-sm"></date-picker>
                    <br>
                    <small style="font-size: 10px; color: red;" v-if="chequedate_validate != ''" >{{chequedate_validate}}</small>
                    </td> 
                  </tr>
                </tbody>
              </table>
              <b-modal title="Add More Option" no-close-on-esc no-close-on-backdrop v-model="largeModal" class="modal-info"  hide-footer @ok="largeModal = false">
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="name">Batch</label>
                      <input type="text" class="form-control" autocomplete="off"  name="cmp_phone" v-model="batchmd" placeholder="Enter Batch">
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="name">Serial Number </label>
                      <input type="text" class="form-control" id="cmp_email" name="cmp_email" v-model="serialmd" autocomplete="off"  placeholder="Enter Serial Number">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="name">Discount Percentage</label>
                      <input type="text" class="form-control" name="cmp_phone" v-model="percentagemd" autocomplete="off"  placeholder="Enter Discount Percentage"  >
                      <small  class="form-text text-muted"  ><strong style="color: red;">{{haserror.dis}}</strong></small>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="name">Discount Amount </label>
                      <input type="text" class="form-control" id="cmp_disc" v-model="amtmd" name="cmp_disc" autocomplete="off"  placeholder="Enter Discount Amount"  >
                      <small  class="form-text text-muted"  ><strong style="color: red;">{{haserror.amt}}</strong></small>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label for="name">Tax Inclusive</label>
                      <input type="checkbox" name="cmp_inclusive" autocomplete="off"  v-model="inclusive">
                      <small class="form-text text-muted"><strong style="color: red;">{{haserror.inclusive}}</strong></small>
                    </div>
                  </div>
                </div>
                <div class="card-footer modal_footer">
                  <button type="submit" class="btn btn-sm btn-primary" @click="savemodal(indexval)"><i class="fa fa-dot-circle-o"></i> Save</button>
                </div>
              </b-modal>


              <!-- changes in popup modal -->
              <b-modal title="Select Variant" size="sm" no-close-on-esc no-close-on-backdrop  v-model="smallmodal"  hide-footer @ok="smallmodal = false" >
                <div class="row">
                  <div class="col-sm-12">
                    <div class="form-group">
                      <model-list-select :list="variantvalue" option-value="variant_id" option-text="variant_id" v-model="variantdata" placeholder="Search Variant Value" @input="onSelectvariant($event)"></model-list-select>
                    </div>
                  </div>
                </div>
              </b-modal>
              <!-- end  -->
            </div>
          </div>
          <div class="card-footer">
            <button type="submit" class="btn btn-sm btn-primary" @click="finalsubmit">
              <i class="fa fa-dot-circle-o"></i> Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <Spinner v-if="loading"></Spinner>
  </div>
</template>

<script>
  import Spinner from '../../spinner.vue'
  import DatePicker from 'vue2-datepicker'
  export default {
   components: {
    'date-picker':  DatePicker,
    Spinner
  },
  data () {
    return {
      all_unit:null,
      dd_show:true,
      purchase_id:null,
      shop_id:null,
      item_seqnos:null,
      selectsupname:null,
      selectshopname:null,
       amt_rec: '',
      chequeno_validate:'',
      chequedate_validate:'',
      prod_lst:[],
        // lst_prod_var:[],
        oldshp:null,
        is_cs_gst:true,
        is_i_gst:true,
        company_gst:'',
        supplier_gst:'',
        variantindex:null,
        smallmodal:false,
        fullpay:true,
        chqpay:false,
        parpay:false,
        chng:0,
        bal:0,
        totalamtreceived:'',
        totalparamtreceived:'',
        cheque_no:'',
        cheque_date:'',
        variantvalue:[],
        variantdata:null,
        loading:false,
        batchmd:'',
        serialmd:'',
        percentagemd:'',
        amtmd:'',
        inclusive:false,
        indexval:null,
        largeModal:false,
        customername:[],
        selected_pytype:'full',
        lst_paymenttype:[
        { value: 'full', text: 'Full' },
        { value: 'partial', text: 'Partial' },
        { value: 'no', text: 'No' },
        ],
        selected_pymode:'cash',
        selectedcustomer:null,
        shopname:[],
        selectshop:null,
        productname:[],
        selectproduct:{},
        rows:[],
        barcode:'',
        haserror:{
          amt:'',
          dis:'',
          cust:'',
          message:'',
          inclusive:'',
          shop:''
        },
        detail:{
          totprddis:'',
          addition:'',
          tot:'',
          cgst:'',
          sgst:'',
          igst:'',
          taxamt:'',
          totalamtpay:'',
          totalamtpendingpay:''
        }
      }
    },

    computed: {
      totaldis() {
        var all =this.rows.reduce((total,row) => {
          if(Number(row.amtmd1)==0){
            return total +  (Number(row.qty)*Number(row.price)*Number(row.percentagemd1))/100;
          }else{
            return total +  (Number(row.amtmd1));
          }
        }, 0);
        all = all.toFixed(4);
        this.detail.totprddis=all;
        return all;
      },
      totalamt() {
        var all =this.rows.reduce((total,row) => {
          return total +  Number(row.amt);
        }, 0);
        all = all.toFixed(4);
        this.detail.tot=all;
        return all;
      },
      totalcgst() {
        var all =this.rows.reduce((total,row) => {
          return total +  ((Number(row.cgst)*Number(row.amt))/100);
        }, 0);
        all = all.toFixed(4);
        this.detail.cgst=all;
        return all;
      },
      totalsgst() {
        var all =this.rows.reduce((total,row) => {
          return total +  ((Number(row.sgst)*Number(row.amt))/100);
        }, 0);
        all = all.toFixed(4);
        this.detail.sgst=all;
        return all;
      },
      totaligst() {
        var all =this.rows.reduce((total,row) => {
          return total +  ((Number(row.igst)*Number(row.amt))/100);
        }, 0);
        all = all.toFixed(4);
        this.detail.igst=all;
        return all;
      },
      totaltax() {
        var all =this.rows.reduce((total,row) => {
          return total +  (Number(row.amttotal)-Number(row.amt));
        }, 0);
        all = all.toFixed(4);
        this.detail.taxamt=all;
        return all;
      },
      totalamtpay(){
        var all =this.rows.reduce((total,row) => {
          return total +  (Number(row.amttotal));
        }, 0);
        all = all.toFixed(4);
        if(this.detail.addition==''){
          this.detail.totalamtpay=all;
          return all
        }else{
          this.detail.totalamtpay=all-parseFloat(this.detail.addition);
          return all-parseFloat(this.detail.addition);
        }
      }
    },

    created(){
      for (var i = 0; i <3; i++) {
        this.rows.push({ productnamex:[],selectedproductid:null,unit:'',unitvalue:'',selectproductrow:null,price:'', qty:'',amt:'', cgst:0, sgst:0,igst:'',amttotal:0,batchmd1:'',serialmd1:'',percentagemd1:'', amtmd1:'',variantrow:'n/a',show:false,show1:false,avaqty:'',maxqty:'',priceqty:'', inclusive1:false, err_qty:'', err_price:'', err_sgst:'', err_cgst:'', err_igst:'',productExist:'',item_seqno: ''})
      }
      
      this.shopuser();
      Promise.all([this.searchcustomer(),this.searchshops(),this.listproduct(),this.getUnit()]).then(ret_val => {
        this.loadPurchaseData(); 
      });
    },

    methods:{

       async getUnit(){
        var _this = this
        this.$http.get('/api/Unittypes/getUnit').then(function(response){
          // console.log(response)
          _this.all_unit = response.data.data
          if(_this.all_unit !== null){
            return Promise.resolve(true);
          }
        });
      },
     
      calchnge(){
        var regexp = /^[1-9]\d*(\.\d+)?$/
        if(this.totalamtreceived !== ''){
          if(regexp.test(this.totalamtreceived) === false){
            alert('Please Enter Valid Amount')
            this.totalamtreceived = ''
            return
          }else{
            this.chng = (parseFloat(this.totalamtreceived) - parseFloat(this.detail.totalamtpay)).toFixed(4)
          }
        }
      },

      calbalance(){
        var regexp = /^[1-9]\d*(\.\d+)?$/
        if(this.totalparamtreceived !== ''){
          if(regexp.test(this.totalparamtreceived) === false){
            alert('Please Enter Valid Amount')
            this.totalparamtreceived = ''   
            return
          }else{
            this.bal = (parseFloat(this.detail.totalamtpay) - parseFloat(this.totalparamtreceived)).toFixed(4)
          }
        }
      },

      paychange(select_paytype_val){
        this.selected_pytype = select_paytype_val
        this.fullpay = false
        this.parpay = false
        if(this.selected_pytype === 'full'){
          this.fullpay = true
          if(this.selected_pymode == 'cheque'){
            this.chqpay = true
          }
          else{
            this.chqpay = false
          }
        }
        else if(this.selected_pytype === 'partial'){
          this.parpay = true
          if(this.selected_pymode == 'cheque'){
            this.chqpay = true
          }
          else{
            this.chqpay = false
          }
        }
        else{
          this.chqpay = false
        }
      },

      modechange(select_paymode_val){
        this.selected_pymode = select_paymode_val
        if(this.selected_pytype !== 'no'){
          if(this.selected_pymode == 'cheque'){
            this.chqpay = true
          }
          else{
           this.chqpay = false 
         }
       }
       else{
        this.chqpay = false 
      }
    },

    loadPurchaseData(){
      if('purchaseId' in this.$route.params){
        this.dd_show = false
        this.rows.length = 0
        this.purchase_id = this.$route.params.purchaseId
        this.shop_id = this.$route.params.shopId
        this.item_seqnos = this.$route.params.itemSeqs
          // this.old_shop_id = this.$route.params.shopId
          var __this = this
          this.$http.get('/api/purchases/loadData?filter[where][purchase_id]='+__this.purchase_id+'&filter[where][est_shop_id]='+__this.shop_id).then(function(res){

           if(res.status == 200){
            var select_sup = __this.customername.filter(function(each){
              return each.supplier_id === res.data.pur_dtl.supplier_id
            });
            __this.selectedcustomer = select_sup[0]
            __this.selectsupname = __this.selectedcustomer.sup_cmp_name
            // __this.supplier_gst = __this.selectedcustomer.
            var select_shop = __this.shopname.filter(function(each){
              return each.est_shop_id === res.data.pur_dtl.est_shop_id
            });
            __this.selectshop = select_shop[0]
            __this.selectshopname = __this.selectshop.est_shop_name

            for(var i = 0; i < res.data.item_data.length; i++){      

              if(__this.item_seqnos.indexOf(res.data.item_data[i].item_seq_no) !== -1){
                var pur_disc_amt = ''
                if(parseFloat(res.data.item_data[i].pur_disc_amt).toFixed(3) != '0.000'){
                  pur_disc_amt = parseFloat(res.data.item_data[i].pur_disc_amt).toFixed(4)
                }

                var pur_disc_pct = ''
                if(parseFloat(res.data.item_data[i].pur_disc_pct).toFixed(3) != '0.000'){
                  pur_disc_pct = parseFloat(res.data.item_data[i].pur_disc_pct)
                }

                var igst = ''
                if(parseFloat(res.data.item_data[i].igst_amt).toFixed(3) != '0.000'){
                  igst = parseFloat(res.data.item_data[i].igst_amt).toFixed(4)
                }

                var sgst = ''
                if(parseFloat(res.data.item_data[i].sgst_amt).toFixed(3) != '0.000'){
                  sgst = parseFloat(res.data.item_data[i].sgst_amt).toFixed(4)
                }

                var cgst = ''                    
                if(parseFloat(res.data.item_data[i].cgst_amt).toFixed(3) != '0.000'){
                  cgst = parseFloat(res.data.item_data[i].cgst_amt).toFixed(4)
                }

                var show = true
                var show1 = false
                var variant_val = ''
                if(res.data.item_data[i].variant_id != null &&  res.data.item_data[i].variant_id != ''){
                  show = false
                  show1 = true
                  variant_val = res.data.item_data[i].variant_id
                }

                var prod_dt = __this.prod_lst.filter(function(each){
                  return each.product_id === res.data.item_data[i].product_id
                });

                  // var new_row = {productnamex:prod_dt,selectedproductid:'',price:res.data.item_data[i].product_unit_cost,unit:res.data.item_data[i].unit_id,unitvalue:'',selectproductrow:prod_dt[0],qty:res.data.item_data[i].purchase_qty,amt:res.data.item_data[i].sub_total, cgst:cgst, sgst:sgst, igst:igst,amttotal:res.data.item_data[i].amt_to_pay,batchmd1:res.data.item_data[i].batch,serialmd1:res.data.item_data[i].serialno,percentagemd1:pur_disc_pct, amtmd1:pur_disc_amt,variantrow:variant_val, inclusive1:res.data.item_data[i].tax_inclusive, salepricemd1:0, is_adjustment:false, adjustment_list:[], adjusted:[], err_qty:'', err_price:'', err_sgst:'', err_cgst:'', err_igst:'',showvariant:showvariant_val,novariant:novariant_val,productExist:'',item_seqno:res.data.item_data[i].item_seq_no}

                  // console.log(new_row)
                // __this.rows.push(new_row)
                  var unit_value=''
                  if(res.data.item_data[i].unit_id in __this.all_unit){
                    unit_value=__this.all_unit[res.data.item_data[i].unit_id]
                  }  
                __this.rows.push({productnamex:prod_dt,
                  selectedproductid:'',
                  unit:unit_value,
                  unitvalue:res.data.item_data[i].unit_id,
                  selectproductrow:prod_dt[0],
                  price:res.data.item_data[i].product_unit_cost, 
                  qty:res.data.item_data[i].max_qty,
                  amt:res.data.item_data[i].sub_total, 
                  cgst:cgst, sgst:sgst, igst:igst,
                  amttotal:res.data.item_data[i].amt_to_pay,
                  batchmd1:res.data.item_data[i].batch,serialmd1:res.data.item_data[i].serialno,
                  percentagemd1:pur_disc_pct, amtmd1:pur_disc_amt,
                  variantrow:variant_val,
                  show:false,
                  show1:true,
                  avaqty:'',
                  maxqty:res.data.item_data[i].max_qty,
                  priceqty:'',
                  inclusive1:res.data.item_data[i]. tax_inclusive, 
                  err_qty:'', err_price:'', err_sgst:'', err_cgst:'', err_igst:'',productExist:'',
                  item_seqno:res.data.item_data[i].item_seq_no})
              }
            }
            __this.onSelectSup(__this.selectedcustomer)
               // __this.detail.igst = response.data[0].igst_amt
                // console.log(__this.rows)
              }
              else{
                console.log('Didnt got response')
              }
            }).catch(function(error){
            })
          }
          else{
            return
          }
        },

        checkShop(){
          if(!this.selectedcustomer)
          {
            this.haserror.cust="Select Supplier"
            this.barcode=''
          }else{this.haserror.cust=''}

          if(!this.selectshop)
          {
            this.haserror.shop="Select Shop"
            this.barcode=''
          }else{this.haserror.shop=''}
        },

        searchBarcode(){
          var option = {}
          var index = 0
          var addRow = 0
          var barcode = this.barcode
          if(this.selectshop != null){
            var shopid = this.selectshop.est_shop_id
          }
          this.barcode = ''
          var _this = this
          var searchText = ''
          if(barcode){
            this.$http.get('/api/purchasereturns/joinproduct?data='+searchText+'&data2='+shopid+'&barcode='+barcode).then(function (response) {
             var valueArr = _this.rows.map(item => item)
             var rowindex = -1
             var check =  valueArr.some(function(value,indx){

              if(value.selectproductrow == null){
                rowindex = indx

                return true }else {return false}
              })
             if(response.data[0])
             { 
               if(_this.rows.length == 0 || rowindex == -1){
                rowindex = rowindex != -1 ? rowindex : _this.rows.length
                _this.rows.push({ productnamex:[],selectedproductid:'',unit:'',unitvalue:'',selectproductrow:null,price:'', qty:'',amt:'', cgst:0, sgst:0,igst:'',amttotal:0,batchmd1:'',serialmd1:'',percentagemd1:'', amtmd1:'', variantrow:'n/a', inclusive1:false, salepricemd1:0, is_adjustment:false, adjustment_list:[], adjusted:[], err_qty:'', err_price:'', err_sgst:'', err_cgst:'', err_igst:''})
              }
              _this.rows[rowindex].productnamex.push(response.data[0])
              _this.rows[rowindex].selectproductrow=response.data[0]
              _this.openvariant(response.data[0],rowindex)

            }
          }).catch(function(error){console.log('error')})
          }else{}
        },


        nameAndnumber (item) {
          return `${item.sup_cmp_name} - ${item.sup_cmp_phone}`
        },

        shopuser(){
          var _this=this
          this.$http.get('/api/shopusers').then(function(response){

          }).catch(function(error){
            if (error.response.status === 401) {
              localStorage.clear();
              _this.$store.commit('SET_AUTH_USER', null)
              _this.$router.push('/');
            }
            if(error.response.data.error.message === "Cannot read property 'cmpname' of null"){
              localStorage.clear();
              _this.$store.commit('SET_AUTH_USER', null)
              _this.$router.push('/');
            }
          })
        },

        company_data(){
          this.company_gst = this.selectshop.shop_gst
        },

        savevatiantmodal(index){

        },


        onSelectvariant(option){
          var _this = this
          var valueArr = this.rows.map(item => item)
          var temprow = this.rows[this.variantindex]
          var index = this.variantindex
          var rowindex = -1
          // this.rows[this.variantindex]['variantrow']=option.variant_id
          if(option.variant_id === 'No Variant') {
            this.rows[this.variantindex]['variantrow']='n/a';
          }
          else{
            this.rows[this.variantindex]['variantrow']=option.variant_id;
          }
          this.smallmodal=false;
          
          // var curr_prod = this.rows[this.variantindex]['selectproductrow']['product_id']
          // var curr_var = this.rows[this.variantindex]['variantrow']
        
        // if(this.lst_prod_var.length > 0){
        //   if(this.lst_prod_var.indexOf(curr_prod+'_'+curr_var) !== -1){
        //     alert('Item - ' + this.rows[this.variantindex]['selectproductrow']['product_name'] + ' with variant ' + option.variant_value + ' already added above. Kindly select other product')
        //       this.rows[this.variantindex]['selectproductrow']=null;
        //       this.rows[this.variantindex]['variantrow']=null
        //       return
        //   }
        // }
        // this.lst_prod_var[this.variantindex] = curr_prod+'_'+curr_var

          // this.rows[this.variantindex]['variantrow']=option.variant_id
          if(option.unit_id in this.all_unit){
            this.rows[index]['unit']=this.all_unit[option.unit_id]
          } 
          // this.rows[this.variantindex]['unit']=option.unit_id
          this.rows[this.variantindex]['unitvalue']=option.unit_id
          this.rows[this.variantindex]['avaqty']=option.quantity
          if(option.quantity>1){
            this.rows[this.variantindex]['qty']=1
          }else{
            this.rows[this.variantindex]['qty']=0
          }
          this.rows[this.variantindex]['priceqty']=option.last_purprice_aft
          
        },

        show_tax(option,index){
          var _this = this
          this.$http.get('/api/taxrates/findOne?filter[where][tax_id]='+option.tax_gst_id).then(function (response){
            if(_this.company_gst && _this.supplier_gst){
              var company_gst = _this.company_gst.substring(0, 2)
              var supplier_gst = _this.supplier_gst.substring(0, 2)
              _this.rows[index]['inclusive1'] = false
              if(company_gst === supplier_gst){
                _this.rows[index]['cgst'] = response.data.tax_cgst
                _this.rows[index]['sgst'] = response.data.tax_sgst
                _this.rows[index]['igst'] = 0.00
              }else{
                _this.rows[index]['cgst'] = 0.00
                _this.rows[index]['sgst'] = 0.00
                _this.rows[index]['igst'] = response.data.tax_igst
              }
              _this.price(index)
            }else if(_this.supplier_gst === null || _this.supplier_gst === ''){
              _this.rows[index]['inclusive1'] = true
              _this.rows[index]['cgst'] = 0.00
              _this.rows[index]['sgst'] = 0.00
              _this.rows[index]['igst'] = 0.00
              _this.price(index)                
            }else{
                // Enable to edit
                _this.rows[index]['inclusive1'] = false
                _this.rows[index]['cgst'] = response.data.tax_cgst
                _this.rows[index]['sgst'] = response.data.tax_sgst
                _this.rows[index]['igst'] = 0.00
                _this.price(index)
              }
            });
        },


        openvariant_on_product(row, index){
          if('product_id' in row.selectproductrow){
            this.openvariant(row,index)
          }
          else{
            return false
          }
        },

        openvariant(option,index){
          var _this=this
          this.variantindex=index
          if(option.selectproductrow == undefined){
            this.rows[index].selectproductrow = option
          }

          var prdctid = option.selectproductrow == undefined ? option.product_id : this.rows[index].selectproductrow.product_id
          var shopid = option.selectproductrow == undefined ? option.est_shop_id : this.rows[index].selectproductrow.est_shop_id

          var tempoption = option.selectproductrow == undefined ? option : option.selectproductrow
          this.show_tax(tempoption,index)
          this.$http.get('/api/estshopinventories/getinventory?filter[where][product_id]='+prdctid+'&filter[where][est_shop_id]='+shopid).then(function (response){
           _this.rows[index]['selectedproductid']=response.data;
           
           if(response.data.length>1){
            _this.rows[index]['show']=true;
            _this.rows[index]['show1']=false;
            _this.rows[index]['selectedproductid']=response.data;
            _this.variantvalue=response.data
            for(var i=0;i<_this.variantvalue.length;i++){
              if(_this.variantvalue[i]['variant_id'] === 'n/a'){
                _this.variantvalue[i]['variant_id'] = 'No Variant'
              }
            }
            _this.smallmodal=true
            if(response.data[0].unit_id in _this.all_unit){
              _this.rows[index]['unit']=_this.all_unit[response.data[0].unit_id]
            }            
            _this.rows[index]['unitvalue']=response.data[0].unit_id
            _this.rows[index]['avaqty']=response.data[0].quantity
            if(response.data[0].quantity>1){
              _this.rows[index]['qty']=1
            }else{
              _this.rows[index]['qty']=0
            }
            _this.rows[index]['priceqty']=response.data[0].last_purprice_aft
            _this.rows[index]['variantrow']=response.data[0].variant_id
          }else{
            _this.variantvalue=response.data
            if(response.data[0].variant_id==="n/a"){
              _this.rows[index]['variantrow']="n/a"
              
              if(response.data[0].unit_id in _this.all_unit){
                _this.rows[index]['unit']=_this.all_unit[response.data[0].unit_id]
              } 
              _this.rows[index]['unitvalue']=response.data[0].unit_id

              // _this.rows[index]['unit']=response.data[0].unit_id
              _this.rows[index]['avaqty']=response.data[0].quantity

              if(response.data[0].quantity>1){
                _this.rows[index]['qty']=1
              }
              else{
                _this.rows[index]['qty']=0
              }

              _this.rows[index]['priceqty']=response.data[0].last_purprice_aft

              _this.rows[index]['show']=false;
              _this.rows[index]['show1']=true;

            }else{
              // _this.rows[index]['unit']=response.data[0].unit_id
              if(response.data[0].unit_id in _this.all_unit){
                _this.rows[index]['unit']=_this.all_unit[response.data[0].unit_id]
              } 
              _this.rows[index]['unitvalue']=response.data[0].unit_id
              _this.rows[index]['avaqty']=response.data[0].quantity
              _this.rows[index]['priceqty']=response.data[0].last_purprice_aft
              if(response.data[0].quantity>1){
                _this.rows[index]['qty']=1
              }else{
                _this.rows[index]['qty']=0
              }
              _this.rows[index]['variantrow']=response.data[0].variant_id;
              _this.rows[index]['show']=false;
              _this.rows[index]['show1']=true;
            }
          }
        }).catch(function (error) {
        });
        
        // _this.rows[index]['inclusive1'] = false

      },

      openmodal(test){
        this.largeModal=true
        this.indexval=test
        this.batchmd='';
        this.serialmd='';
        this.percentagemd='';
        this.amtmd='';
        if(this.rows[test]['percentagemd1']!=''){
          this.percentagemd=this.rows[test].percentagemd1;
        }
        if(this.rows[test].amtmd1!=''){
          this.amtmd=this.rows[test].amtmd1;
        }
        this.inclusive=this.rows[test].inclusive1;
      },

      addRow1(){
        this.rows.push({ productnamex:[],selectedproductid:null,unit:'',selectproductrow:null,price:'', qty:'',amt:'', cgst:0, sgst:0,igst:'',amttotal:0,batchmd1:'',serialmd1:'',percentagemd1:'', amtmd1:'',variantrow:'n/a',show:false,show1:false, avaqty:'',priceqty:'', inclusive1:false, err_qty:'', err_price:'', err_sgst:'', err_cgst:'', err_igst:'',productExist:''})
      },

      removeElement: function(index) {
        this.rows.splice(index, 1);
      },

      // searchshops(){
      //   var _this = this
      //   this.$http.get('/api/shopusers/getShop').then(function (response){
      //     _this.shopname=response.data
      //     for (var i = 0; i < response.data.length; i++) {
      //       if(response.data.length == i+1){
      //         _this.selectshop = response.data[i]
      //         _this.company_data();
      //       }
      //     }
      //   }).catch(function (error) {
      //     console.log("error.response");  
      //   });
      // },

      async searchshops(){
        var response = await this.$http.get('/api/shopusers/getShop')
        this.shopname = response.data
        var len = response.data.length - 1
        this.selectshop = response.data[len]
        if(this.shopname.length > 0){
          this.company_data();
          return Promise.resolve(true);
        }
      },

      async listproduct(){
        var _this = this
        var response = await this.$http.get('/api/companyproducts')
        _this.prod_lst=response.data
        if(_this.prod_lst.length > 0){
          return Promise.resolve(true);
        }
      },

      searchprd3(searchText,index,row){

        this.haserror.cust=''
        this.haserror.shop=''
        var status = 1
        if(this.selectedcustomer==null || this.selectedcustomer.supplier_id === undefined){
          status = 0
          this.haserror.cust="Please Select Supplier"
        }
        if(this.selectshop==null || this.selectshop.est_shop_id === undefined){
          status = 0
          this.haserror.shop="Please Select Shop"
        }

        if(status == 1){
          var shopid = this.selectshop.est_shop_id
          var _this=this
          var barcode = ''
          if(searchText)
          {
            this.$http.get('/api/purchasereturns/joinproduct?data='+searchText+'&data2='+shopid+'&barcode='+barcode).then(function (response) {
              row.productnamex=response.data
            }).catch(function (error) {
              console.log(error);  
            });
          }
        }

      },

      onSelectShp(){
        this.company_data();
        this.onSelectSup(this.selectedcustomer);

        if(this.oldshp != this.selectshop.est_shop_id){
          this.oldshp = this.selectshop.est_shop_id
          for (var i = this.rows.length-1; i >=0;  i--) {
            this.rows.splice(i,1);
          }
          for (var i = 0; i <2; i++) {
            this.rows.push({ productnamex:[],selectedproductid:null,unit:'',selectproductrow:null,price:'', qty:'',amt:'', cgst:0, sgst:0,igst:'',amttotal:0,batchmd1:'',serialmd1:'',percentagemd1:'', amtmd1:'',variantrow:'n/a',show:false,show1:false, avaqty:'',priceqty:'', inclusive1:false, err_qty:'', err_price:'', err_sgst:'', err_cgst:'', err_igst:'',productExist:''})
          }
        }
      },

      onSelectSup(option){
        this.is_cs_gst = true
        this.is_i_gst = true

        if(option.sup_cmp_gst != undefined){
          this.haserror.cust=''
          this.supplier_gst=option.sup_cmp_gst
        }

        if(this.company_gst && this.supplier_gst){
          var company_gst = this.company_gst.substring(0, 2)
          var supplier_gst = this.supplier_gst.substring(0, 2)
          if(company_gst === supplier_gst){
            this.is_cs_gst = true
            this.is_i_gst = false
          }else{
            this.is_cs_gst = false
            this.is_i_gst = true
          }
        }else if(this.supplier_gst === null || this.supplier_gst === ''){
          this.is_cs_gst = false
          this.is_i_gst = false
        }else{
          this.is_cs_gst = true
          this.is_i_gst = true
        }

        if(this.rows.length > 0){
          for (var i = 0; i < this.rows.length; i++) {
            if(this.rows[i].selectproductrow != null){

              this.show_tax(this.rows[i].selectproductrow,i)
            }
          }
        }

      },

      async searchcustomer(){
        var _this=this
        var response = await this.$http.get('/api/suppliers')
        _this.customername=response.data
        if(_this.customername.length > 0){
          return Promise.resolve(true);
        }
      },

      savemodal(val){
        var num=/^([0-9]{1,2}|100)$/
        var num1=/^[0-9]{1,12}$/
        var amt_reg = /^[0-9]\d{0,11}(\.\d{1,6})??$/
        this.haserror.amt=''
        this.haserror.dis=''
        
        if( this.percentagemd!='' && this.amtmd!=''){
          this.haserror.amt="AnyOne Is Required"
        }
        else if(this.percentagemd!='' &&  num.test(this.percentagemd)==false){
          this.haserror.dis="Please Provide Integer Between 1-100"                       
        }
        else if(this.amtmd!='' && amt_reg.test(this.amtmd)==false){                                                  
          this.haserror.amt="Please Provide Valid Amount"                      
        }
        else if(parseFloat(this.amtmd)>parseFloat(this.rows[val]['amt'])){
         this.haserror.amt="Discount Amount Cannot Be Greater Than Provided Amount"  
       }
       else{
         this.rows[val]['batchmd1']=this.batchmd
         this.rows[val]['serialmd1']=this.serialmd
         this.rows[val]['percentagemd1']=this.percentagemd
         this.rows[val]['amtmd1']=this.amtmd
         this.rows[val]['inclusive1']=this.inclusive
         this.largeModal=false;
         this.price(val);
       }
     },

     discountadd(){
      // var num=/^[0-9]{1,11}$/
      var num=/^\d{1,12}(\.\d{1,6})?$/
      if(num.test(this.detail.addition)==false && this.detail.addition!='' ){
        this.detail.addition='';
        alert("Please Provide Valid Integer For Additional Discount");
      }
      if(parseFloat(this.detail.totalamtpay)<=0){
        this.detail.addition='';
        alert("Addition Discount Cannot Be Greater Than Total Amount To Pay")
      }
    },

    price(index){
      var num=/^[0-9]{1,11}$/
      var price = /^\d{1,12}(\.\d{1,6})?$/
      var tax = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(50)?$/
      var igstexp = /^[0-9]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(100)?$/
      var num1=/^[0-9]{1,8}$/

      if(parseFloat(this.rows[index]['qty'])<=0.00){
        this.rows[index]['err_qty'] = 'Invalid Quantity';
      }else if(price.test(this.rows[index]['qty'])==false  && this.rows[index]['qty']!=''){
        this.rows[index]['err_qty'] = 'Invalid Quantity';
      }else if(parseFloat(this.rows[index]['qty'])>parseFloat(this.rows[index]['avaqty'])){
        this.rows[index]['qty'] = ''
        this.rows[index]['err_qty'] = 'Cannot Be Greater Than Available Quantity';
      }else{
        this.rows[index]['err_qty'] = '';
      }


      if(this.rows[index]['price']==''){
        this.rows[index]['err_price'] = 'Required';
      }else if(parseFloat(this.rows[index]['price'])<=0.00){
        this.rows[index]['err_price'] = 'Invalid Price';
      }else if(price.test(this.rows[index]['price'])==false  && this.rows[index]['price']!=''){
        this.rows[index]['err_price'] = 'Invalid Price';
      }else{
        this.rows[index]['err_price'] = '';
        this.rows[index]['price'] = parseFloat(this.rows[index]['price']).toFixed(4)
      }


      if(igstexp.test(this.rows[index]['igst'])==false && this.rows[index]['igst']!=''){
        this.rows[index]['igst']=''
        this.rows[index]['err_igst'] = 'Invalid';
      }else if(parseFloat(this.rows[index]['igst'])<0){
        this.rows[index]['igst']=''
        this.rows[index]['err_igst'] = 'Invalid';
      }else{
        this.rows[index]['err_igst'] = '';
      }

      if(tax.test(this.rows[index]['cgst'])==false  && this.rows[index]['cgst']!=0 ){
        this.rows[index]['cgst']=0
        this.rows[index]['err_cgst'] = 'Invalid';
      }else if(parseFloat(this.rows[index]['cgst'])<0){
        this.rows[index]['cgst']=0
        this.rows[index]['err_cgst'] = 'Invalid';
      }else{
        this.rows[index]['err_cgst'] = '';          
      }


      if(tax.test(this.rows[index]['sgst'])==false  && this.rows[index]['sgst']!=0){
        this.rows[index]['sgst']=0
        this.rows[index]['err_sgst'] = 'Invalid';
      }else if(parseFloat(this.rows[index]['sgst'])<0){
        this.rows[index]['sgst']=0
        this.rows[index]['err_sgst'] = 'Invalid';
      }else{
        this.rows[index]['err_sgst'] = '';
      }


      if(this.rows[index]['igst']!=''){
        this.rows[index]['cgst'] = 0
        this.rows[index]['sgst'] = 0
        var igst_value = parseFloat(this.rows[index]['igst'])
      }else{
        this.rows[index]['igst']=''
        var igst_value = 0
      }

      if(this.rows[index]['qty']!='' && this.rows[index]['price']!=''){
        var qty=parseFloat(this.rows[index]['qty'])
        var price=parseFloat(this.rows[index]['price'])
        var total=  qty*price;
      }else if(this.rows[index]['qty']=='' && this.rows[index]['price']==''){
        var qty = 0
        var price = 0
        var total = qty*price;
      }else if(this.rows[index]['qty']!='' && this.rows[index]['price']==''){
        var qty = parseFloat(this.rows[index]['qty'])
        var price = 0
        var total = qty*price;
      }else if(this.rows[index]['qty']=='' && this.rows[index]['price']!=''){
        var qty = 0
        var price = parseFloat(this.rows[index]['price'])
        var total = qty*price;
      }

      if(this.rows[index]['percentagemd1']!=''){
        total=total-(total*this.rows[index]['percentagemd1'])/100
      }
      if(this.rows[index]['amtmd1']!=''){
        total=total-parseFloat(this.rows[index]['amtmd1'])
      }

      if(total!=undefined){
        if(this.rows[index]['inclusive1'] == false){
          this.rows[index]['amt']=total.toFixed(4);
          var amttotal=total+(this.rows[index]['sgst']*total)/100 + (this.rows[index]['cgst']*total)/100 + (igst_value*total)/100
          amttotal = amttotal.toFixed(4);
          this.rows[index]['amttotal']=amttotal
        }else if(this.rows[index]['inclusive1'] == true){
          amttotal = total.toFixed(4);
          this.rows[index]['amttotal']=amttotal
          var total_percentage = parseFloat(this.rows[index]['sgst']) + parseFloat(this.rows[index]['cgst']) + igst_value
          var bfttotal = (total * (100/(100 + total_percentage)))
          this.rows[index]['amt']=bfttotal.toFixed(4);
        }
      }
    },


    finalsubmit(){
      this.haserror.message=''
      this.haserror.cust='';
      this.haserror.shop='';
      var submit = 0
      var num=/^[0-9]{1,11}$/
      var price = /^\d{1,12}(\.\d{1,6})?$/
      var tax = /^[0-4]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(50)?$/
      var igstexp = /^[0-9]{0,1}[0-9]{0,1}(\.[0-9]{1,3})?$|^(100)?$/


      for (var i = this.rows.length-1; i >=0;  i--) {
        if(this.rows[i].selectproductrow!=null){

          if(this.rows[i].price==''){
            submit = 1
            this.rows[i].err_price = 'Required';
          }else if(parseFloat(this.rows[i].price)<0){
            submit = 1
            this.rows[i].err_price = 'Invalid Price';
          }else if(price.test(this.rows[i].price)==false  && this.rows[i].price!=''){
            submit = 1
            this.rows[i].err_price = 'Invalid Price';
          }

          if(this.rows[i].qty==''){
            submit = 1
            this.rows[i].err_qty = 'Required';
          }else if(parseFloat(this.rows[i].qty)<=0.00){
            submit = 1
            this.rows[i].err_qty = 'Invalid Quantity';
          }else if(price.test(this.rows[i].qty)==false  && this.rows[i].qty != ''){
            submit = 1
            this.rows[i].err_qty = 'Invalid Quantity';
          }else if(this.rows[i].maxqty !== ''){
            if(parseFloat(this.rows[i].qty) > parseFloat(this.rows[i].maxqty)){
             submit = 1
             this.rows[i].err_qty = 'Qty should be less than or equal to max qty';
           }
         }

         if(igstexp.test(this.rows[i]['igst'])==false && this.rows[i]['igst']!=''){
          this.rows[i]['igst']=''
          this.rows[i]['err_igst'] = 'Invalid';
          submit = 1
        }else if(parseFloat(this.rows[i]['igst'])<0){
          this.rows[i]['igst']=''
          this.rows[i]['err_igst'] = 'Invalid';
          submit = 1
        }

        if(tax.test(this.rows[i]['cgst'])==false  && this.rows[i]['cgst']!=0){
          this.rows[i]['cgst']=0
          this.rows[i]['err_cgst'] = 'Invalid';
          submit = 1
        }else if(parseFloat(this.rows[i]['cgst'])<0){
          this.rows[i]['cgst']=0
          this.rows[i]['err_cgst'] = 'Invalid';
          submit = 1
        }


        if(tax.test(this.rows[i]['sgst'])==false  && this.rows[i]['sgst']!=0){
          this.rows[i]['sgst']=0
          this.rows[i]['err_sgst'] = 'Invalid';
          submit = 1
        }else if(parseFloat(this.rows[i]['sgst'])<0){
          this.rows[i]['sgst']=0
          this.rows[i]['err_sgst'] = 'Invalid';
          submit = 1
        }

      }
    }

    if(this.selectedcustomer==null || this.selectedcustomer.supplier_id==null || this.selectshop==null || this.selectshop.est_shop_id==null){
      if(this.selectshop==null || this.selectshop.est_shop_id==null){
        this.haserror.shop="Please Select Shop"
      }
      if(this.selectedcustomer==null || this.selectedcustomer.supplier_id==null){
        this.haserror.cust="Please Select Supplier"
      }
    }else{
      for (var i = this.rows.length-1; i >=0;  i--) {
        if(this.rows[i].selectproductrow==null){
          this.rows.splice(i,1);
        }
      }
      if(this.rows.length==0){
        alert("nothing to Save");
      }else{
        var _this=this
        if(this.detail.totalamtpay==''){
          alert("Nothing To Save");
        }
        else{
          if(submit == 0){
             this.amt_rec = ''
              this.chequeno_validate=''
              this.chequedate_validate=''
          //   if(this.selected_pytype === 'full'){
          //     if(parseInt(this.chng) < 0){
          //       alert('Invalid Entry - Change Amt Cannot Be Negative - Please Select Valid Payment Type(Partial)')
          //       this.totalamtreceived = ''
          //       this.chng = 0
          //       return
          //     }
          //     this.detail.totalamtpendingpay = 0
          //   }
          //   else if(this.selected_pytype === 'partial'){
          //     if(parseInt(this.bal) < 0){
          //       alert('Invalid Entry - Balance Amount Cannot Be Negative - Please Select Valid Payment Type(Full)')
          //       this.totalparamtreceived = ''
          //       this.bal = 0
          //       return
          //     }
          //     this.detail.totalamtpendingpay = this.bal
          //   }
          //   else{
          //    this.detail.totalamtpendingpay = this.detail.totalamtpay 
          //  }
              if (this.selected_pytype === 'partial') {
              var chk_partail=false

              if (parseInt(this.totalparamtreceived) == 0 || this.totalparamtreceived == '') {
                this.totalparamtreceived = ''
                this.amt_rec = 'Required'
                this.bal = 0                
                chk_partail=true
              }
              if (parseInt(this.bal) < 0) {
                this.totalparamtreceived = ''
                this.amt_rec = 'Invalid Entry - Balance Amount Cannot Be Negative - Please Select Valid Payment Type(Full)'
                this.bal = 0
                chk_partail=true

              }
              if(this.selected_pymode == 'cheque' && this.cheque_no == ''){
                this.chequeno_validate='Required'
                chk_partail=true
              }
              if(this.selected_pymode == 'cheque' && this.cheque_date == ''){
                this.chequedate_validate='Required'
                chk_partail=true
              }

              if (chk_partail == true) {
                return
              }
              
              this.detail.totalamtpendingpay = this.bal

            }else if(this.selected_pytype === 'full'){
              this.detail.totalamtpendingpay = 0
              var chk_full=false           
              if (this.selected_pymode == 'cheque' && this.cheque_no == '') {
                this.chequeno_validate='Required'
                chk_full=true
              }
              if(this.selected_pymode == 'cheque' && this.cheque_date == '') {
                this.chequedate_validate='Required'
                chk_full=true

              }                
              if (chk_full==true) {
                return
              }                
              
            }
            else{
              this.detail.totalamtpendingpay = this.detail.totalamtpay
            }

             if(this.cheque_date != ''){
              var daynum = /^[0-9]{1}$/
              let date = new Date(this.cheque_date)
              var year = date.getFullYear()
              var month = date.getMonth()+1;
              var day = date.getDate();

              if(daynum.test(month)==true){
                var month='0'+month
              }else{
                var month=month
              }

              if(daynum.test(day)==true){
                var day='0'+day
              }else{
                var day=day
              }
              var dateval = year+'-'+month+'-'+day
            }else{
              var dateval = null
            }
           this.loading=true  
           var data={}
           data.suppliersid=this.selectedcustomer.supplier_id
           data.shopid=this.selectshop.est_shop_id
           data.pur_items=this.rows
           data.total_discount=this.detail.totprddis
           data.additional=this.detail.addition
           data.amt_before_tax=this.detail.tot
           data.cgst=this.detail.cgst
           data.sgst=this.detail.sgst
           data.igst=this.detail.igst
           data.taxamt=this.detail.taxamt
           data.totalamtpay=this.detail.totalamtpay
           data.purchase_id = this.purchase_id
           data.totalamtpendingpay = this.detail.totalamtpendingpay
           data.pay = {'paytype': '', 'paymode': '', 'chqno': '', 'chqdt': '', 'amt': 0}
           data.pay.paytype = this.selected_pytype
           data.pay.paymode = this.selected_pymode
           data.pay.chqno = this.cheque_no
           data.pay.chqdt = dateval
           data.pay.amt = parseFloat(this.detail.totalamtpay) - parseFloat(this.detail.totalamtpendingpay)
           
           this.$http.post('/api/purchasereturns/rtdata', data).then(function (response) {
           _this.loading=false; 
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;                                 
            _this.haserror.message= 'Purchase Returned Successfully';
            setTimeout(function(){ _this.haserror.message='';}, 2000);
            if('purchaseId' in _this.$route.params){
              _this.$router.push({ name: 'Purchase Entry'})
            }
            else{
              _this.reset()
            }
          })
           .catch(function (error) {
            _this.loading=false
          });
         }
         else{
          return
        }
      }
    }
  }
},
reset(){
  this.selectedcustomer=null
  this.selectshop=null
  this.detail.totprddis=''
  this.detail.addition=''
  this.detail.tot=''
  this.detail.cgst=''
  this.detail.sgst=''
  this.detail.igst=''
  this.detail.taxamt=''
  this.detail.totalamtpay=''
  this.detail.totalamtpendingpay=''
  for (var i = this.rows.length-1; i >=0;  i--) {
    this.rows.splice(i,1);
  }
  for (var i = 0; i <2; i++) {
   this.rows.push({ productnamex:[],selectedproductid:null,unit:'',unitvalue:'',selectproductrow:null,price:'', qty:'',amt:'', cgst:0, sgst:0,igst:'',amttotal:0,batchmd1:'',serialmd1:'',percentagemd1:'', amtmd1:'',variantrow:'n/a',show:false,show1:false,avaqty:'',priceqty:'', inclusive1:false, err_qty:'', err_price:'', err_sgst:'', err_cgst:'', err_igst:'',productExist:''})
 }
}
}
}
</script>

<style type="text/css">
  @media screen and (min-width: 768px) {
    .table-responsive {
      width: 100%;
      margin-bottom: 15px;
      overflow-x: auto;
      overflow-y: hidden;
      -webkit-overflow-scrolling: touch;
      -ms-overflow-style: -ms-autohiding-scrollbar;
      border: 1px solid #DDD;
    }
  }
  .table th, .table td{
    padding:0.25rem; 
  }
  .fa{
    cursor: pointer !important;
  }
  .select2-container--default .select2-selection--single{
    border-radius: 0px;
    margin-top: -34px;
    margin-left: 13px;
  }
  .select2-container--default .select2-selection--single .select2-selection__arrow{
    top: 33px;
  }
  .sale_plus{
    padding-left: 4px;
    color: green;
  }
  .v-select.single .selected-tag + input[type="search"] { padding: 0; width: 0px !important; }
  .select2-dropdown{
    width: 194px !important;
    margin-top: -6px;
    margin-left: 13px;
  }
  .v-autocomplete-list{
    background-color: red !important;
    z-index: 99999 !important;
  }
  .sbx-facebook{
    width:207px !important; 
  }
  .sbx-facebook{
    margin-left: -184px !important;
    border: 1px solid #aaa;
    width: 270px !important;
    height: 30px;
  }
  .sbx-facebook__reset{
    display: none !important;
  }
  .form-control-sm {
    border: 1px solid rgba(34, 36, 38, 0.15);
  }
</style>


// WEBPACK FOOTER //
// src/views/purches/Addpurchesreturn.vue